import { IconJourneyItem } from '@components/icons/journey-icon';
import { Sidebar, useSidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { JourneyTemplateType } from 'api/types';

export const useJourneyDetailsSidebar = () =>
  useSidebar(JourneyDetailsSidebar, {
    variant: 'REGULAR',
  });

export const JourneyDetailsSidebar = ({
  journeyTemplate,
}: {
  journeyTemplate: JourneyTemplateType;
}) => {
  const { t } = useScopedTranslate(locale);

  return (
    <Sidebar>
      <Sidebar.SimpleHeader
        title={t('journeyDetails')}
        icon={IconJourneyItem}
        iconColor="elementBlue100"
      />
      <Sidebar.Content>
        <>
          <Stack space={4}>
            <Text text={journeyTemplate.title} font="heading2" />
            {journeyTemplate.description ? (
              <Text text={journeyTemplate.description} font="regular14" />
            ) : (
              <Text text={t('noDescriptionAdded')} font="regular14" color="textHelper" />
            )}
          </Stack>
        </>
      </Sidebar.Content>
    </Sidebar>
  );
};

export const locale = {
  en: {
    journeyDetails: 'Journey details',
    title: 'Title',
    description: 'Description',
    noDescriptionAdded: 'No description added',
  },
};
